import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { from, catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { attachAndForward } from './auth.interceptor';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router   = inject(Router);
  const keycloak = inject(KeycloakService);
  const auth     = inject(AuthService);

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401) {
        // Force-refresh the token once and retry the original request.
        // Only navigate to /login if the refresh itself fails.
        return from(keycloak.updateToken(-1)).pipe(
          switchMap(() => attachAndForward(req, next, auth)),
          catchError(() => {
            router.navigate(['/login']);
            return throwError(() => err);
          }),
        );
      }
      // 403 is handled by route guards; don't redirect here
      // so that components can show their own error states
      return throwError(() => err);
    }),
  );
};
